<template>
  <div class="d-flex flex-column bg-light align-items-center">
    <header-novo-usuario class="fixed-top" />
    <b-container
      fluid
      class="min-vh-100 d-flex align-items-center justify-content-center"
      style="padding-top: 80px"
    >
      <b-row class="w-100 justify-content-center">
        <b-col cols="12" md="8" lg="6" xl="5">
          <b-card class="text-center p-4">
            <h2 class="text-success mb-3">Confirmação de E-mail</h2>
            <p>
              Olá, enviamos um e-mail de confirmação para o endereço
              cadastrado.<br />
              Por favor, acesse seu e-mail e clique no link de confirmação para
              ativar sua conta.
            </p>
            <b-form-group
              label="Digite o código de verificação recebido por e-mail:"
              label-for="codigo-verificacao"
              class="mt-3"
            >
              <b-form-input
                id="codigo-verificacao"
                v-model="codigo"
                placeholder="Código de verificação"
                class="text-center"
              ></b-form-input>
            </b-form-group>
            <b-button
              variant="outline-secondary"
              class="mt-3 mr-2"
              @click="reenviarEmail"
            >
              Reenviar e-mail de confirmação
            </b-button>
            <b-button
              :variant="
                isDev
                  ? 'secondary'
                  : isHml
                  ? 'primary'
                  : 'success'
              "
              class="mt-3"
              @click="confirmarCodigo"
            >
              Verificar
            </b-button>
            <b-alert v-if="mensagem" variant="success" show class="mt-3">
              {{ mensagem }}
            </b-alert>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import HeaderNovoUsuario from "@/components/novo-usuario/Header.vue";
import { isDev, isHml, store } from "@/store";
import novoUsuarioService from "@/services/administracao/novoUsuarioService";
const CompProps = Vue.extend({
  name: "ConfirmaCodigo",
  components: { HeaderNovoUsuario },
});

@Component
export default class ConfirmaCodigo extends mixins(UtilsTS, CompProps) {
  mensagem = "";
  codigo = "";
  isDev = isDev();
  isHml = isHml();

  async reenviarEmail(): Promise<void> {
    store.blockScreen = true;
    try {
      await novoUsuarioService.reenviarCodigoEmail();
      this.$toast.success("Código reenviado com sucesso!");
    } catch (e: any) {
      this.tratarError(e, true);
    } finally {
      store.blockScreen = false;
    }
  }
  async confirmarCodigo(): Promise<void> {
    store.blockScreen = true;
    try {
      await novoUsuarioService.confirmarCodigoEmail(this.codigo);
      this.$toast.success("Código confirmado com sucesso!");
      this.$router.push('/');
    } catch (e: any) {
      this.tratarError(e, true);
    } finally {
      store.blockScreen = false;
      this.codigo = "";
    }
  }
}
</script>

<style scoped>
.text-center {
  font-family: "Montserrat", sans-serif;
}
</style>
